import React from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router";

import ButtonTabs from "@components/ButtonTabs/ButtonTabs";
import ImageSlickSlider from "@components/shared/ImageSlickSlider/ImageSlickSlider";
import {
  ResourceInfoType,
  UnitDetailsBlockPropType,
} from "@models/components/units.model";
import { getLocationType, locationType } from "@models/services/organisation";
import { userProfile } from "@models/services/user";
import { applyLocalization } from "@services/common.service";

import Address from "../Address/Address";
import FeaturesBlock from "../FeaturesBlock/FeaturesBlock";
import OpeningHoursBlock from "../OpeningHoursBlock/OpeningHoursBlock";
import UnitInformation from "../UnitInformation/UnitInformation";

import "react-modern-drawer/dist/index.css";

const terminology = {
  default: {
    plural: "Tests",
    singular: "Test",
  },
  locales: {
    en: {
      plural: "Tests",
      singular: "Test",
    },
  },
};

const UnitDetailsBlock: React.FC<UnitDetailsBlockPropType> = ({
  contactList,
  handleTabChange,
  locationId,
  resourceDetails,
  resourceInfo,
}) => {
  const { t } = useTranslation();
  const context: [getLocationType, locationType, userProfile] =
    useOutletContext();

  const addressProps = {
    address: applyLocalization(resourceInfo?.info?.address),
    title: applyLocalization(resourceInfo?.info?.title),
    unitName: t("howToFindThisUnit", {
      unit: applyLocalization(
        context?.[1]?.resourceType?.terminology?.singular
      ),
    }),
  };

  return (
    <>
      <div className="fg-location-block" data-testid="unit-details-block">
        <ButtonTabs
          tabs={resourceDetails}
          selectedTab={resourceInfo?.id}
          handleTabChange={
            handleTabChange as (tab: ResourceInfoType | locationType) => void
          }
        />
      </div>
      {resourceInfo?.id ? (
        <div
          className="row fg-border-bottom"
          data-testid="unit-details-information"
        >
          <div className="col-sm-12 col-lg-8">
            <UnitInformation
              resourceInfo={resourceInfo}
              contactList={contactList}
              locationId={locationId}
              unitId={resourceInfo?.id}
            />
            <FeaturesBlock
              resourceInfo={resourceInfo}
              terminology={terminology}
            />
            <Address {...addressProps} />
          </div>
          <div className="col-sm-12 col-lg-4">
            {resourceInfo?.images?.length > 0 && (
              <div className="fg-tab-unit-list fg-border-none pt-0">
                <ImageSlickSlider image={resourceInfo?.images} />
              </div>
            )}

            <div className="fg-tab-welcome-block fg-border-none d-none d-lg-block">
              <OpeningHoursBlock
                resourceInfo={resourceInfo}
                terminology={terminology}
              />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default UnitDetailsBlock;
